import React from "react"
import "./style.css"

const Footer = () => {
  return (
    <>
    <footer class="border-top py-4">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 first">
        <a class="navbar-brand" href="#"><h1 class="">
          <span class="text-success">B</span><span class="text-warning">UU</span><span class="text-success">CA</span>
           </h1></a>
           <h3 class="">Get the app</h3>
           <p class="lead text-muted ">BUUCA App is now available on Google Play & App</p>
            <img src="./image/store1.jpg" alt="no image" />
      </div>
      <div class="col-lg-3 first">
        <h4 class="fw-bold">Information</h4>
        <ul class="footer-list text-dark">
          <li><a className='list-item' href="">About us</a></li>
          <li><a className='list-item' href="">Shipping Policy</a></li>
          <li><a className='list-item' href="">Terms & Condition</a></li>
          <li><a className='list-item' href="">Privacy Policy</a></li>
          <li><a className='list-item' href="">Contact Us</a></li>
          
        </ul>
      </div>
      <div class="col-lg-3 first">
        <h4 class="fw-bold">User Area</h4>
        <ul class="footer-list">
          <li><a  className='list-item' href="">My account</a></li>
          <li><a className='list-item' href="">My Cart</a></li>
          <li><a className='list-item' href="">Login</a></li>
          <li><a className='list-item' href="">Checkout</a></li>
          
          
        </ul>
      </div>
      <div class="col-lg-3">
        <h4 class="fw-bold">Contact Info</h4>
        <p>9211001101001010</p>
        <p>601 133 5434 -issued in London</p>
        <p>Support@Arbaz.com</p>
      </div>
    </div>
    <hr/>
    <div class="copyright text-center mt-2">
      <a href="">Copyright 2022 <span class="text-danger fw-bold">Webarbaz</span></a>
    </div>
  </div>
</footer>
    </>
  )
}

export default Footer
